<div [nbSpinner]="loading">
    <h1 id="title" class="title color-brand">{{ "AUTH.TITLE-REGISTER" | translate }}</h1>
    <p class="sub-title">{{ "AUTH.SUB-TITLE-REGISTER" | translate }}</p>
    <nb-alert *ngIf="alert.show" [status]="alert.type" role="alert" class="text-center">
        {{ alert.message }}
    </nb-alert>

    <nb-stepper linear #stepper *ngIf="!errors?.length" disableStepNavigation>
        <nb-step>
            <p class="error-message" *ngIf="message && statusCode === 1">{{ message }}</p>
            <form [formGroup]="formPreRegister">
                <div class="row">
                    <div class="col-12">
                        <div class="form-control-group">
                            <nb-checkbox formControlName="estrangeiro" id="input-estrangeiro">{{
                                "USER.FOREIGNER" | translate
                            }}</nb-checkbox>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-control-group">
                            <label class="label" for="input-name">{{
                                (prControls.estrangeiro.value ? "USER.PASSPORT" : "USER.DOCUMENT") | translate
                            }}</label>
                            <input
                                nbInput
                                fullWidth
                                name="document"
                                id="input-document"
                                placeholder="{{ 'USER.DOCUMENT' | translate }}"
                                autofocus
                                [mask]="isBrazil && !prControls.estrangeiro.value ? '000.000.000-09' : null"
                                formControlName="document"
                                [status]="prControls.document.dirty && prControls.document.invalid ? 'danger' : 'basic'"
                            />
                            <div class="text-hint mt-2" *ngIf="isBrazil">
                                <nb-icon icon="alert-circle-outline"></nb-icon>
                                <span class="caption-1 ml-2">{{ "REGISTER.DOCUMENT-HINT" | translate }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-control-group">
                    <label class="label" for="input-name">{{ "GENERAL.MAIL" | translate }}</label>
                    <input
                        nbInput
                        fullWidth
                        name="email"
                        id="input-email"
                        type="email"
                        placeholder="{{ 'GENERAL.MAIL' | translate }}"
                        formControlName="email"
                        [status]="prControls.email.dirty && prControls.email.invalid ? 'danger' : 'basic'"
                    />
                </div>
                <div class="form-control-group">
                    <label class="label" for="input-name">{{ "USER.ZIPCODE" | translate }}</label>
                    <input
                        nbInput
                        fullWidth
                        name="zipcode"
                        id="input-zipcode"
                        [mask]="isBrazil ? '00000-000' : null"
                        type="tel"
                        placeholder="{{ 'USER.ZIPCODE' | translate }}"
                        formControlName="zip_code"
                        [status]="prControls.zip_code.dirty && prControls.zip_code.invalid ? 'danger' : 'basic'"
                    />
                </div>

                <div class="row small-gutter">
                    <div class="col-lg-3">
                        <label class="label" for="input-ddi">{{ "USER.DDI" | translate }}</label>
                        <input
                            id="ddi"
                            name="ddi"
                            nbInput
                            fullWidth
                            placeholder="{{ 'USER.DDI' | translate }}"
                            formControlName="celular_ddi"
                            [nbAutocomplete]="autocomplete"
                            inputmode="numeric"
                            (input)="onDDIAutocompleteChange($event)"
                            [status]="
                                prControls.celular_ddi.dirty && prControls.celular_ddi.invalid ? 'danger' : 'basic'
                            "
                        />
                        <nb-autocomplete #autocomplete optionsListClass="country-options-list">
                            <nb-option
                                class="d-flex align-items-center"
                                [value]="code.dial_code"
                                *ngFor="let code of countryCodes"
                            >
                                <img
                                    [src]="'assets/flags/1x1/' + code.code.toLowerCase() + '.svg'"
                                    width="16"
                                    height="16"
                                    class="mr-2"
                                />
                                <span>{{ code.name }} ({{ code.dial_code }})</span>
                            </nb-option>
                        </nb-autocomplete>
                    </div>
                    <div class="col-lg-3">
                        <label class="label" for="input-ddd">{{ "USER.DDD" | translate }}</label>
                        <input
                            nbInput
                            fullWidth
                            name="ddd"
                            id="input-ddd"
                            type="tel"
                            [mask]="isBrazil ? '00' : null"
                            placeholder="{{ 'USER.DDD' | translate }}"
                            formControlName="celular_ddd"
                            [status]="
                                prControls.celular_ddd.dirty && prControls.celular_ddd.invalid ? 'danger' : 'basic'
                            "
                        />
                    </div>
                    <div class="col-lg-6">
                        <label class="label" for="input-celular">{{ "USER.CELLULAR" | translate }}</label>
                        <input
                            nbInput
                            fullWidth
                            name="celular"
                            id="input-celular"
                            type="tel"
                            [mask]="isBrazil ? '00000-0000' : null"
                            placeholder="{{ 'USER.CELLULAR' | translate }}"
                            formControlName="celular_numero"
                            [status]="
                                prControls.celular_numero.dirty && prControls.celular_numero.invalid
                                    ? 'danger'
                                    : 'basic'
                            "
                        />
                    </div>
                </div>
                <div class="mt-4">
                    <button
                        nbButton
                        fullWidth
                        status="success"
                        [disabled]="formPreRegister.invalid || loading"
                        (click)="preRegister()"
                    >
                        {{ "BUTTONS.GO" | translate }} <nb-icon icon="arrow-forward-outline"></nb-icon>
                    </button>
                </div>
            </form>
        </nb-step>

        <nb-step>
            <form [formGroup]="formRegister" (ngSubmit)="onRegister()">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-control-group">
                            <label class="label" for="input-name">{{ "USER.FIRST-NAME" | translate }}</label>
                            <input
                                nbInput
                                fullWidth
                                name="first_name"
                                id="input-first-name"
                                placeholder="{{ 'USER.FIRST-NAME' | translate }}"
                                autofocus
                                formControlName="first_name"
                                [status]="controls.first_name.dirty && controls.first_name.invalid ? 'danger' : 'basic'"
                            />
                            <ng-container *ngIf="controls.first_name.invalid && controls.first_name.touched">
                                <p class="error-message" *ngIf="controls.first_name.errors?.required">
                                    {{ "MESSAGE.FIELD.MANDATORY" | translate }}
                                </p>
                            </ng-container>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-control-group">
                            <label class="label" for="input-name">{{ "USER.LAST-NAME" | translate }}</label>
                            <input
                                nbInput
                                fullWidth
                                name="last_name"
                                id="input-last-name"
                                placeholder="{{ 'USER.LAST-NAME' | translate }}"
                                formControlName="last_name"
                                [status]="controls.last_name.dirty && controls.last_name.invalid ? 'danger' : 'basic'"
                            />
                            <ng-container *ngIf="controls.last_name.invalid && controls.last_name.touched">
                                <p class="error-message" *ngIf="controls.last_name.errors?.required">
                                    {{ "MESSAGE.FIELD.MANDATORY" | translate }}
                                </p>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div
                    class="short-name"
                    *ngIf="
                        (controls.first_name.valid && controls.last_name.valid) ||
                        (controls.first_name.disabled && controls.last_name.disabled)
                    "
                >
                    <div class="row">
                        <div class="col-lg-12 w-full d-flex justify-content-end flex-column mb-4">
                            <button
                                type="button"
                                nbButton
                                fullWidth
                                status="info"
                                (click)="handleButtonClick()"
                                [attr.aria-expanded]="!isCollapsed"
                                aria-controls="collapseShortName"
                            >
                                {{
                                    isCollapsed
                                        ? ("REGISTER.ADJUST-SHORT-NAME" | translate)
                                        : ("REGISTER.KEEP-SYSTEM-SUGESTION" | translate)
                                }}
                            </button>
                            <p class="error-message" *ngIf="controls.short_name_field.errors?.required">
                                {{ "MESSAGE.FIELD.MANDATORY" | translate }}
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="w-100" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" [animation]="true">
                            <div cdkDropListGroup>
                                <div class="col-lg-12">
                                    <label class="label">{{ "REGISTER-AVAILABLE-NAMES" | translate }}</label>
                                    <div
                                        class="available-list"
                                        id="available-drop-list"
                                        cdkDropList
                                        cdkDropListSortingDisabled
                                        #availableList="cdkDropList"
                                        [cdkDropListData]="available_names"
                                        [cdkDropListConnectedTo]="[shorNameList]"
                                        (cdkDropListDropped)="drop($event)"
                                    >
                                        <div
                                            class="box"
                                            [cdkDragData]="name"
                                            *ngFor="let name of available_names"
                                            cdkDrag
                                        >
                                            {{ name }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12 py-4">
                                    <label class="label">{{ "USER.SHORT-NAME" | translate }}</label>
                                    <div
                                        class="text-hint mb-2 d-flex dropzone-info"
                                        [ngClass]="{ 'invalid-short-name': controls.short_name_field.invalid }"
                                    >
                                        <span>{{ "USER.MINIMUM-TWO-NAMES" | translate }}</span> |
                                        <span>{{ "USER.MAXIMUM-THREE-NAMES" | translate }}</span>
                                    </div>
                                    <div
                                        class="dropped-list"
                                        [ngClass]="{
                                            'invalid-short-name': controls.short_name_field.invalid,
                                            'box-shadow': enteredInDropList
                                        }"
                                        id="drop-list"
                                        cdkDropList
                                        formArrayName="short_name_field"
                                        #dropListRef
                                        #shorNameList="cdkDropList"
                                        cdkDropListOrientation="horizontal"
                                        [cdkDropListData]="short_name"
                                        [cdkDropListConnectedTo]="[availableList]"
                                        [cdkDropListEnterPredicate]="maximumLimitAllowed"
                                        (cdkDropListDropped)="drop($event)"
                                        (cdkDropListEntered)="dropListEntered()"
                                    >
                                        <div
                                            class="dropzone-placeholder"
                                            [ngClass]="{ 'hide-placeholder': hasDataInDropList }"
                                        >
                                            <nb-icon class="drop-icon" icon="download-outline"></nb-icon>
                                            <p class="placeholder-description">
                                                {{ "REGISTER.DROP-NAMES-HERE" | translate }}
                                            </p>
                                        </div>
                                        <div class="box" [cdkDragData]="name" *ngFor="let name of short_name" cdkDrag>
                                            {{ name }}
                                        </div>
                                    </div>
                                    <div class="text-hint mt-2 d-flex">
                                        <nb-icon class="mr-1" icon="alert-circle-outline"></nb-icon>
                                        <span class="dropzone-info">{{
                                            "REGISTER.REORDER-NAMES-DRAGGING" | translate
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-control-group">
                    <label class="label" for="input-email">{{ "GENERAL.MAIL" | translate }}</label>
                    <input
                        nbInput
                        fullWidth
                        name="email"
                        id="input-email"
                        pattern=".+@.+\..+"
                        placeholder="{{ 'GENERAL.MAIL' | translate }}"
                        autofocus
                        formControlName="email"
                        [status]="controls.email.dirty && controls.email.invalid ? 'danger' : 'basic'"
                    />
                    <ng-container *ngIf="controls.email.invalid && controls.email.touched">
                        <p class="error-message" *ngIf="controls.email.errors?.required">
                            {{ "MESSAGE.FIELD.MANDATORY" | translate }}
                        </p>
                        <p class="error-message" *ngIf="controls.email.errors?.pattern">
                            {{ "MESSAGE.FIELD.INVALID-MAIL" | translate }}
                        </p>
                    </ng-container>
                </div>
                <div class="form-control-group">
                    <label class="label" for="input-birth_date">{{ "USER.BIRTH-DATE" | translate }}</label>
                    <input
                        nbInput
                        [nbDatepicker]="datepicker"
                        fullWidth
                        name="birth_date"
                        id="input-birth_date"
                        placeholder="{{ 'USER.BIRTH-DATE' | translate }}"
                        formControlName="dt_birthday"
                    />
                    <nb-datepicker #datepicker></nb-datepicker>
                    <ng-container *ngIf="controls.dt_birthday.invalid && controls.dt_birthday.touched">
                        <p class="error-message" *ngIf="controls.dt_birthday.errors?.required">
                            {{ "MESSAGE.FIELD.MANDATORY" | translate }}
                        </p>
                    </ng-container>
                </div>
                <div class="form-control-group">
                    <label class="label" for="input-gender">{{ "GENERAL.GENDER" | translate }}</label>
                    <nb-select
                        fullWidth
                        placeholder="{{ 'GENERAL.GENDER' | translate }}"
                        formControlName="gender"
                        [selected]="controls.gender.value"
                    >
                        <nb-option [value]="1">{{ "GENERAL.MALE" | translate }}</nb-option>
                        <nb-option [value]="2">{{ "GENERAL.FEMININE" | translate }}</nb-option>
                    </nb-select>
                    <ng-container *ngIf="controls.gender.invalid && controls.gender.touched">
                        <p class="error-message" *ngIf="controls.gender.errors?.required">
                            {{ "MESSAGE.FIELD.MANDATORY" | translate }}
                        </p>
                    </ng-container>
                </div>
                <div class="form-control-group">
                    <div class="row small-gutter">
                        <div class="col-lg-3">
                            <label class="label" for="input-ddi">{{ "USER.DDI" | translate }}</label>
                            <input
                                nbInput
                                name="ddi"
                                id="input-ddi"
                                placeholder="+XX"
                                type="text"
                                formControlName="ddi"
                                mask="+9999"
                                fullWidth
                                [status]="controls.ddi.dirty && controls.ddi.invalid ? 'danger' : 'basic'"
                            />
                        </div>
                        <div class="col-lg-3">
                            <label class="label" for="input-ddi">{{ "USER.DDD" | translate }}</label>
                            <input
                                nbInput
                                name="ddd"
                                id="input-ddd"
                                placeholder="(xx)"
                                type="text"
                                formControlName="ddd"
                                [mask]="isBrazil ? 00 : 000"
                                fullWidth
                                [status]="controls.ddd.dirty && controls.ddd.invalid ? 'danger' : 'basic'"
                            />
                        </div>
                        <div class="col-lg-6">
                            <label class="label" for="input-cellphone">{{ "USER.CELLULAR" | translate }}</label>
                            <input
                                nbInput
                                name="cellphone"
                                id="input-cellphone"
                                placeholder="xxxxx-xxxx"
                                type="text"
                                formControlName="cel_number"
                                [mask]="isBrazil ? '00000-0000' : null"
                                fullWidth
                                [status]="controls.cel_number.dirty && controls.cel_number.invalid ? 'danger' : 'basic'"
                            />
                            <ng-container *ngIf="controls.cel_number.invalid && controls.cel_number.touched">
                                <p class="error-message" *ngIf="controls.cel_number.errors?.required">
                                    {{ "MESSAGE.FIELD.MANDATORY" | translate }}
                                </p>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <!-- PAÍS, ESTADO -->
                <div class="form-control-group">
                    <div class="row">
                        <!-- PAIS -->
                        <div class="col-lg-3">
                            <label class="label" for="input-country">{{ "USER.COUNTRY" | translate }}</label>
                            <nb-select
                                id="input-country"
                                placeholder="País"
                                formControlName="country"
                                fullWidth
                                (selectedChange)="onLocaleChange('country', $event)"
                            >
                                <nb-option *ngFor="let country of locale.countries" [value]="country.id_pais">{{
                                    country.descricao
                                }}</nb-option>
                            </nb-select>

                            <ng-container *ngIf="controls.country.invalid && controls.country.touched">
                                <p class="error-message" *ngIf="controls.country.errors?.required">
                                    {{ "MESSAGE.FIELD.MANDATORY" | translate }}
                                </p>
                            </ng-container>
                        </div>

                        <!-- ESTADO -->
                        <div class="col-lg-4">
                            <label class="label" for="input-state_id">{{ "USER.STATE" | translate }}</label>
                            <nb-select
                                id="input-state_id"
                                placeholder="Estado"
                                formControlName="state"
                                fullWidth
                                (selectedChange)="onLocaleChange('state', $event)"
                            >
                                <nb-option *ngFor="let state of locale?.states" [value]="state.id_uf">{{
                                    state.descricao
                                }}</nb-option>
                            </nb-select>

                            <ng-container *ngIf="controls.state.invalid && controls.state.touched">
                                <p class="error-message" *ngIf="controls.state_id.errors?.required">
                                    {{ "MESSAGE.FIELD.MANDATORY" | translate }}
                                </p>
                            </ng-container>
                        </div>

                        <!-- CIDADE -->
                        <div class="col-lg-5">
                            <label class="label" for="input-city_id">{{ "USER.CITY" | translate }}</label>
                            <nb-select id="input-state_id" placeholder="Cidade" formControlName="city" fullWidth>
                                <nb-option *ngFor="let city of locale?.cities" [value]="city.id_cidade">{{
                                    city.descricao
                                }}</nb-option>
                            </nb-select>

                            <ng-container *ngIf="controls.city.invalid && controls.city.touched">
                                <p class="error-message" *ngIf="controls.city.errors?.required">
                                    {{ "MESSAGE.FIELD.MANDATORY" | translate }}
                                </p>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="form-control-group">
                    <label class="label" for="input-password">{{ "AUTH.PASSWORD" | translate }}</label>
                    <input
                        nbInput
                        name="password"
                        id="input-password"
                        placeholder="********"
                        type="password"
                        formControlName="password"
                        fullWidth
                        [status]="controls.password.dirty && controls.password.invalid ? 'danger' : 'basic'"
                    />
                    <ng-container *ngIf="controls.password.invalid && controls.password.touched">
                        <p class="error-message" *ngIf="controls.password.errors?.required">
                            {{ "MESSAGE.FIELD.MANDATORY" | translate }}
                        </p>
                        <p class="error-message" *ngIf="controls.password.errors?.minlength">
                            {{ "MESSAGE.FIELD.MIN-LENGTH" | translate }}
                        </p>
                    </ng-container>
                </div>
                <div class="form-control-group">
                    <label class="label" for="input-confirmPassword">{{ "AUTH.CONFIRM-PASSWORD" | translate }}</label>
                    <input
                        nbInput
                        name="confirmPassword"
                        id="input-confirmPassword"
                        placeholder="********"
                        type="password"
                        formControlName="confirm_password"
                        fullWidth
                        [status]="
                            controls.confirm_password.dirty && controls.confirm_password.invalid ? 'danger' : 'basic'
                        "
                    />
                    <ng-container *ngIf="controls.confirm_password.invalid && controls.confirm_password.touched">
                        <p class="error-message" *ngIf="controls.confirm_password.errors?.required">
                            {{ "MESSAGE.FIELD.MANDATORY" | translate }}
                        </p>
                        <p class="error-message" *ngIf="controls.confirm_password.errors?.minlength">
                            {{ "MESSAGE.FIELD.MIN-LENGTH" | translate }}
                        </p>
                        <p class="error-message" *ngIf="controls.confirm_password.errors?.notMatch">
                            {{ "MESSAGE.FIELD.PASS-MATCH" | translate }}
                        </p>
                    </ng-container>
                </div>
                <!-- <div style="display: none; justify-content: center; flex-wrap: wrap; margin-bottom: 12px">
                <re-captcha
                    (resolved)="resolved($event)"
                    siteKey="6LeclOUgAAAAAK_OxUwUuzFz8DhMWzA053zQ-1jO"
                    formControlName="recaptcha"
                ></re-captcha>
                <ng-container *ngIf="controls.recaptcha.invalid && controls.recaptcha.touched">
                    <p
                        class="error-message"
                        *ngIf="controls.recaptcha.errors?.required"
                        style="width: 100%; text-align: center; margin-bottom: 12px"
                    >
                        {{ "MESSAGE.FIELD.MANDATORY" | translate }}
                    </p>
                </ng-container>
            </div> -->
                <div class="form-control-group policies">
                    <nb-checkbox formControlName="accept"
                        >{{ "AUTH.AGREEMENT" | translate }}
                        <a
                            [routerLink]="['/privacy-policy']"
                            [fragment]="policy.id_politica"
                            target="_blank"
                            *ngFor="let policy of policies; let index = index"
                            class="d-inline-block mr-2"
                            >#{{ index + 1 }} {{ policy.descricao }}</a
                        ></nb-checkbox
                    >
                </div>
                <button nbButton fullWidth status="success" type="submit" [disabled]="formRegister.invalid || loading">
                    {{ "BUTTONS.REGISTER" | translate }} <nb-icon icon="checkmark-circle-outline"></nb-icon>
                </button>
            </form>
        </nb-step>
        <nb-step>
            <p class="paragraph text-center">
                <strong>{{ "GENERAL.ALL-SET" | translate }}</strong> <br />
                {{ "REGISTER.STEP-TOKEN-REQUEST" | translate }}
            </p>
            <app-token-request
                [player]="player"
                (sent)="onTokenSent($event)"
                type="1"
                *ngIf="player"
            ></app-token-request>
        </nb-step>
        <nb-step>
            <app-token-validate
                type="1"
                [player]="player"
                [codeToken]="codeToken"
                [typeSending]="typeSending"
                (validate)="onValidationSuccess()"
                *ngIf="stepper.selectedIndex === 3 && codeToken"
            ></app-token-validate>
        </nb-step>
    </nb-stepper>

    <div class="errors" *ngIf="errors?.length">
        <p class="paragraph">{{ message }}</p>
        <nb-card *ngIf="errors?.length">
            <app-user-found *ngFor="let user of errors" [user]="user"></app-user-found>
        </nb-card>
        <button nbButton (click)="onRecoverPassClick()">
            {{ "AUTH.RECOVER-PASS" | translate }} <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
        </button>
    </div>
</div>
